import {downloadApk} from '@/utils';
import React, {useMemo} from 'react';
import {inApp, inGameBox, isPWA} from '@/utils/interface';
import {stopBeforeDownload} from '@/utils/utils';
import {Image} from 'antd-mobile';
import {useTranslation} from 'react-i18next';

const Download: React.FC = () => {
  const [show, setShow] = React.useState(true);
  const toDownload = () => {
    if (stopBeforeDownload()) {
      return;
    }
    downloadApk();
  };
  const _isPWA = useMemo(() => isPWA(), []);
  const {t} = useTranslation();
  if (inApp || inGameBox || _isPWA) {
    return null;
  }
  return show ? (
    <div className="bg-gradient-to-r from-[#421FA8] to-[#0F0049] flex flex-row items-center justify-between px-3 py-2">
      <div className="flex flex-row items-center gap-2">
        <Image
          className="size-[2.375rem]"
          src={require('@assets/icons/logo.webp')}
        />
        <div className="flex flex-col items-start justify-center gap-1 font-medium">
          <span className="text-white font-bold">PLINKBET GAME</span>
          <span className="text-white opacity-70 text-[.625rem] tracking-tight">
            {t('home.tip.downloadDesc')}
          </span>
        </div>
      </div>
      <div
        className="w-[6.5rem] h-9 bg-no-repeat bg-full cursor-pointer"
        onClick={toDownload}
        style={{
          backgroundImage: `url(${require('@/assets/icons/home/download.webp')})`,
        }}
      />
      <div
        className="size-[1.125rem] bg-no-repeat bg-full cursor-pointer"
        onClick={() => setShow(false)}
        style={{
          backgroundImage: `url(${require('@/assets/icons/close-new.webp')})`,
        }}
      />
    </div>
  ) : (
    <></>
  );
};

export default Download;
